import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  scrollPositionSubject = new Subject();
  scrollToTopSubject = new Subject();

  constructor() {
  }
}
